@if (modalStep == 'portab_1') {
  <div>
    <div class="icon-center small">
      <i class="fas fa-exchange-alt"></i>
    </div>
    <h3 class="title mt-2 mt-md-4 mb-1">
      Aproveite o que temos a oferecer
    </h3>
    <h4 class="subtitle mb-2 mb-md-4">
      Conheça mais sobre portabilidade e suas vantagens de portar ao Viva Mais Previdência <a href="https://arquivos.vivamaisprev.com.br/material_portabilidade.pdf" target="_blank">clicando aqui</a>.
    </h4>
    <p class="text-center my-3 my-md-5">Faça sua <strong><a routerLink="/simulador/escolha" target="_blank">simulação</a></strong> de portabilidade para Viva Mais Previdência.</p>
    <div class="row justify-content-center text-center">
      <a class="btn btn-outline-success mx-2 mb-2 mb-md-0" target="_blank" [href]="urlChat">Contato com um consultor</a>
      <button class="btn btn-primary mx-2" (click)="modalStep = 'portab_2'">Solicitar Portabilidade</button>
    </div>
  </div>
}

@if (modalStep == 'portab_2') {
  <div>
    <form [formGroup]="form">
      <div class="icon-center small">
        <i class="fas fa-exchange-alt"></i>
      </div>
      <div class="row justify-content-center text-center mt-3">
        <div class="file btn btn-outline-primary mx-2">
          Anexar Documento
          <input type="file" name="file" (change)="handleFileInput($event)" formControlName="nomeArquivo"/>
        </div>
        @if (arq1Nome==null) {
          <p class="small w-100">Nenhum documento anexado.</p>
        }
        @if (arq1Nome!=null) {
          <p class="small w-100">Arquivo Selecionado: <strong>{{arq1Nome}}</strong></p>
        }
      </div>
      <h4 class="subtitle bigger my-4 my-md-5">
        Para que um consultor do plano Viva Mais Previdência possa analisar os seus dados, anexe o extrato do seu plano de previdência ou preencha as informações abaixo.
      </h4>
      <div class="row my-4">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="form-group">
            <input class="mb-4 form-control" type="text" placeholder="Nome Completo da Entidade Cedente" formControlName="entidadeCedente">
            @if (this.form.get('entidadeCedente').invalid && (this.form.get('entidadeCedente').touched || this.form.get('entidadeCedente').dirty)) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
          <div class="form-group">
            <input class="mb-4 form-control" type="text" placeholder="Nome do Plano de Benefício" formControlName="planoReceptor">
            @if (!this.form.get('planoReceptor').valid) {
              <div>
                @if (this.form.get('planoReceptor').dirty) {
                  <div>
                    <small class="text-danger">
                      Celular Inválido
                    </small>
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <input class="mb-4 form-control" type="text" placeholder="Número de Identificação do Plano" formControlName="numIdentificacaoPlano">
            @if (this.form.get('numIdentificacaoPlano').invalid && (this.form.get('numIdentificacaoPlano').touched || this.form.get('numIdentificacaoPlano').dirty)) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
          <div class="form-group">
            <input class="mb-4 form-control" type="text" placeholder="Processo CNPB/Susep" formControlName="cnpb">
            @if (this.form.get('cnpb').invalid && (this.form.get('cnpb').touched || this.form.get('cnpb').dirty)) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
          <div class="form-group">
            <input class="mb-4 form-control" type="text" placeholder="Modalidade do Plano"  formControlName="modalidadePlano">
            @if (this.form.get('modalidadePlano').invalid && (this.form.get('modalidadePlano').touched || this.form.get('modalidadePlano').dirty)) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
          <div class="form-group">
            <input class="mb-4 form-control" type="text" placeholder="Valor a ser Portado"
              formControlName="valor"
              maxlength="16"
              mask="separator.2"
              prefix="R$ "
              thousandSeparator="."
              decimalMarker=","
              [dropSpecialCharacters]="true"                        >
              @if (this.form.get('valor').invalid && (this.form.get('valor').touched || this.form.get('valor').dirty)) {
                <div>
                  <small class="text-danger">
                    Campo Obrigatório
                  </small>
                </div>
              }
            </div>
            <div class="form-group">
              <label>Opção de Regime Tributário:</label>
              <select class="form-control" formControlName="regimeTributario">
                <option value="Progressivo">Progressivo</option>
                <option value="Regressivo">Regressivo</option>
              </select>
              @if (this.form.get('regimeTributario').invalid && (this.form.get('regimeTributario').touched || this.form.get('regimeTributario').dirty)) {
                <div>
                  <small class="text-danger">
                    Campo Obrigatório
                  </small>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row justify-content-center text-center">
          <button class="btn btn-success mx-2" target="_blank" (click)="enviarSolicitacao()" [disabled]="!form.valid || loading">
            Enviar Solicitação
            @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      </form>
    </div>
  }

  @if (modalStep == 'portab_3') {
    <div>
      <div class="icon-center small">
        <i class="far fa-check-circle"></i>
      </div>
      <h3 class="title my-2 my-md-4">
        Seus dados foram enviados ao Consultor
      </h3>
    </div>
  }